"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.r2d2 = r2d2;
exports.cookie = cookie;
const axios_1 = __importDefault(require("axios"));
function r2d2(in_, requestUrl) {
    return axios_1.default.post(requestUrl, Object.assign(Object.assign({ app: "NS_Container", ua: window === null || window === void 0 ? void 0 : window.navigator.userAgent, user: in_.user || cookie("user_id"), tracker: in_.tracker || cookie("trackerid") }, in_), { edata: Object.assign(Object.assign({}, (in_.edata || {})), { anonymousID: webengageAnonymousID(), ga_client_id: getGAClientID(), is_js: true, platform: window.innerWidth < 480 ? "mweb" : "web", web_engage: true }), odata: Object.assign(Object.assign({}, (in_.odata || {})), { url: window === null || window === void 0 ? void 0 : window.location.href }) }), {
        withCredentials: true,
        timeout: 2000,
    });
}
function getGAClientID() {
    try {
        return window["ga"].getAll()[0].get("clientId");
    }
    catch (_a) {
        return "";
    }
}
function webengageAnonymousID() {
    let aid = cookie("we_aid");
    if (aid !== undefined)
        return aid;
    try {
        // @ts-ignore
        aid = window.webengage.user.getAnonymousId();
    }
    catch (_a) {
        aid = "";
    }
    return aid;
}
function cookie(key) {
    if (typeof document === "undefined")
        return;
    if (document.cookie.indexOf(`${key}=`) === -1)
        return;
    return document.cookie.split(`${key}=`)[1].split(";")[0];
}
//# sourceMappingURL=r2d2.js.map